import { render, staticRenderFns } from "./UserActivityDetails.vue?vue&type=template&id=29dd4a94"
import script from "./UserActivityDetails.vue?vue&type=script&lang=js"
export * from "./UserActivityDetails.vue?vue&type=script&lang=js"
import style0 from "./UserActivityDetails.vue?vue&type=style&index=0&id=29dd4a94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports